export default __webpack_public_path__ + "static/media/dashboard.1da8f08f.png";